import { WebStorageStateStore } from 'oidc-client';
import * as $ from 'jquery';
declare var require: any

const configJson = $.ajax({
  url: '../assets/config/config.json',
  async: false,
}).responseText;
const configJsonVal = JSON.parse(configJson);
export const environment = {
  SERVER_URL: `./`,
  production: false,
  useHash: false,
  hmr: false,
  supportedLocale: ['zh_CN', 'zh_TW', 'en'],
  matomoConfig: {
    trackerUrl: configJsonVal.matomoConfig.trackerUrl,
    siteId: configJsonVal.matomoConfig.siteId,
  },
  // VERSION: require('../../package.json').version,
  authConfig: {
    authority: `${configJsonVal.IDMAuthorityUrl}/auth`,
    client_id: configJsonVal.IDMClientId,
    // client_secret: 'secret',
    redirect_uri: `${configJsonVal.APPURL_FOR_IDM}/auth/callback`,
    post_logout_redirect_uri: `${configJsonVal.APPURL_FOR_IDM}`,
    RequireClientSecret: false,
    // response_type: 'id_token token',
    response_type: 'code',//authorization-code
    silent_redirect_uri: `${configJsonVal.APPURL_FOR_IDM}/auth/silent`,
    scope: 'openid profile email',
    loadUserInfo: true,
    automaticSilentRenew: true,
    revokeAccessTokenOnSignout: true,
    filterProtocolClaims: false,
    // silentRequestTimeout:10000,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  },
};
